// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24xMk","delete":"styles_delete__2BVht","update":"styles_update__3XXmG","add":"styles_add__397RV"};